import { z } from 'zod';

// GET /v3/trilha-aprendizagem/escolas/:escolaId/elegibilidade
export const learningPathAvailabilitySchema = z.object({
  escolaId: z.number().int(),
  elegivel: z.boolean(),
});

export type LearningPathAvailability = z.infer<typeof learningPathAvailabilitySchema>;
